import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_API_URL;

const BlogEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    title: "",
    cover: "",
    excerpt: "",
    content: "",
  });

  useEffect(() => {
    fetch(`${API}/api/blogs`)
      .then(res => res.json())
      .then(data => {
        const blog = data.find(b => b._id === id);
        if (blog) setForm(blog);
      });
  }, [id]);

  const handleChange = (e) =>
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleUpdate = async () => {
    const token =
      localStorage.getItem("token") ||
      sessionStorage.getItem("token");

    await fetch(`${API}/api/blogs/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(form),
    });

    navigate("/blogs");
  };

return (
    
  <section className="bg-[#fdfcf7] min-h-screen px-4 pt-28 pb-24">
    <div className="max-w-3xl mx-auto">

      {/* HEADER */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <span className="text-xs font-semibold tracking-widest uppercase text-[#5b6f00]/70">
            CMS / Blogs
          </span>
          <h1 className="text-2xl font-extrabold text-gray-900 mt-1">
            Edit Article
          </h1>
        </div>

        <button
          onClick={() => navigate("/blogs")}
          className="text-sm text-gray-500 hover:text-[#5b6f00] transition"
        >
          ← Back
        </button>
      </div>

      {/* FORM CARD */}
      <div className="bg-white rounded-3xl border border-gray-100 shadow-md p-8 space-y-6">

        {/* TITLE */}
        <div>
          <label className="text-sm font-semibold text-gray-700 mb-1 block">
            Title
          </label>
          <input
            name="title"
            value={form.title}
            onChange={handleChange}
            className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-3
                       text-lg font-semibold text-gray-900
                       focus:outline-none focus:ring-2 focus:ring-[#5b6f00]/30"
          />
        </div>

        {/* COVER */}
        <div>
          <label className="text-sm font-semibold text-gray-700 mb-1 block">
            Cover Image URL
          </label>
          <input
            name="cover"
            value={form.cover}
            onChange={handleChange}
            className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5
                       text-sm text-gray-800
                       focus:outline-none focus:ring-2 focus:ring-[#5b6f00]/30"
          />

          {form.cover && (
            <img
              src={form.cover}
              alt=""
              className="mt-3 w-full h-40 object-cover rounded-xl border border-gray-100"
            />
          )}
        </div>

        {/* EXCERPT */}
        <div>
          <label className="text-sm font-semibold text-gray-700 mb-1 block">
            Excerpt
          </label>
          <textarea
            name="excerpt"
            value={form.excerpt}
            onChange={handleChange}
            rows={3}
            className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-3
                       text-sm text-gray-800 resize-none
                       focus:outline-none focus:ring-2 focus:ring-[#5b6f00]/30"
          />
        </div>

        {/* CONTENT */}
        <div>
          <label className="text-sm font-semibold text-gray-700 mb-1 block">
            Content
          </label>
          <textarea
            name="content"
            value={form.content}
            onChange={handleChange}
            rows={14}
            className="w-full rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4
                       text-sm text-gray-800 font-mono leading-relaxed
                       focus:outline-none focus:ring-2 focus:ring-[#5b6f00]/30"
          />
        </div>

        {/* ACTIONS */}
        <div className="flex items-center gap-4 pt-2">
          <button
            onClick={handleUpdate}
            className="px-6 py-3 rounded-full bg-[#5b6f00] text-white text-sm font-semibold
                       shadow-md hover:bg-[#4a5c00] hover:-translate-y-0.5 transition"
          >
            Update Article →
          </button>

          <button
            onClick={() => navigate("/blogs")}
            className="text-sm text-gray-500 hover:text-gray-800 transition"
          >
            Cancel
          </button>
        </div>

      </div>
    </div>
  </section>
);
};

export default BlogEdit;